import React from 'react';
import Styles from 'src/components/Styles';
import {
  CustomTilesButtonStylesDescriptor,
  PickupLocationListStylesDescriptor,
  RecentOrdersButtonStylesDescriptor,
  ProductModifierStylesDescriptor,
  ProductModifierRadioButton,
  CheckoutBarProps,
} from 'src/components/elements/orderAhead/descriptor/DescriptorType';
import {
  StyleSheet,
  View,
  Text,
  Platform,
  PixelRatio,
  Dimensions,
} from 'react-native';

import {checkValue, formatCurrency} from 'src/Util';
import Localized from 'src/constants/AppStrings';
import {ProductModifierValue} from 'src/types/Menu';
import CartImage from 'src/components/img/svg/CartImage';
import {BarButton} from 'src/components/elements/orderAhead/BarButton';
import CustomToggleComponent, {
  CustomToggleComponentType,
} from 'src/components/elements/CustomToggleComponent';
import AccountStore from 'src/stores/AccountStore';

const screenWidth = Dimensions.get('window').width;

export function customTilesButtonStyles(): CustomTilesButtonStylesDescriptor {
  return StyleSheet.create({
    tileConatainer: {
      flexDirection: 'row',
      alignItems: 'center',
      borderColor: Styles.Colors.PayNew.darkHuesBase04,
      borderWidth: 1,
      borderRadius: Styles.Spacing.m2,
      minWidth: 135,
      paddingHorizontal: Styles.Spacing.m2 + Styles.Spacing.m1,
      justifyContent: 'flex-start',
      paddingVertical: Styles.Spacing.m3,
      overflow: 'hidden',
      backgroundColor: Styles.Colors.PayNew.white01,
    },
    text: {
      fontSize: Styles.Fonts.f7,
      fontWeight: '400',
      color: Styles.darkColor,
      paddingHorizontal: Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.robotoRegular,
      lineHeight: 20,
    },
    selectedView: {
      backgroundColor: 'rgba(64, 159, 104, 0.15)',
      borderColor: Styles.Colors.Canteen.primary,
      borderWidth: 2.5,
      paddingVertical: Styles.Spacing.m3 - 1.5,
    },
    selectedText: {
      color: Styles.Colors.PayNew.black01,
      fontWeight: '700',
    },
  });
}

export function pickupLocationListStyles(): PickupLocationListStylesDescriptor {
  return StyleSheet.create({
    cell: {
      padding: Styles.Spacing.m3,
      borderColor: Styles.lightGray,
      borderWidth: 1,
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: Styles.Spacing.m3,
      borderRadius: Styles.Spacing.m2,
      minHeight: Styles.Heights.touchTargetHeight2,
      overflow: 'hidden',
      backgroundColor: Styles.white,
    },
    cellSelected: {
      flexDirection: 'row',
      borderColor: Styles.primaryColor,
      padding: Styles.Spacing.m3,
      borderWidth: 2.5,
      alignItems: 'center',
      borderRadius: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m3,
      backgroundColor: 'rgba(64, 159, 104, 0.15)',
      overflow: 'hidden',
    },
    label: {
      color: Styles.darkColor,
      fontWeight: '400',
      fontSize: Styles.Fonts.f7,
      paddingLeft: Styles.Spacing.m2,
      paddingRight: Styles.Spacing.m4,
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    selectedLabel: {
      fontWeight: '700',
      fontSize: Styles.Fonts.f7,
      color: Styles.primaryColor,
      paddingLeft: Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.robotoRegular,
    },
  });
}

export function pickupLocationInnerCircleBackgroundColor(): string {
  return Styles.primaryColor;
}

export function pickupLocationOuterCircleBorderColor(): string {
  return Styles.primaryColor;
}

export function productModifierStyles(): ProductModifierStylesDescriptor {
  return StyleSheet.create({
    customizationDivider: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingVertical: Styles.Spacing.m2,
      marginLeft: Styles.Spacing.m2 + 2,
    },
    radioButtonWrapper: {
      padding: Styles.Spacing.m1,
      backgroundColor: Styles.white,
      marginLeft: Styles.Spacing.m0,
      justifyContent: 'center',
    },
    checkboxCalorieContainer: {
      alignItems: 'center',
    },
    checkboxRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      flex: 1,
    },
    checkboxNameContainer: {
      flexDirection: 'column',
      marginRight: Styles.Spacing.m2,
      alignItems: 'flex-start',
      flex: 7,
    },
    checkboxPriceContainer: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      flex: 3,
    },
    titleText: {
      color: Styles.Colors.PayNew.black01,
      fontWeight: '700',
      fontSize: Styles.Fonts.f1,
      flex: 0.8,
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    requiredText: {
      fontSize: Styles.Fonts.f1,
      color: Styles.dangerColor,
      fontStyle: 'italic',
    },
    requiredViewStyles: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: Styles.Spacing.m2,
      marginBottom: Styles.Spacing.m2,
    },
    options: {
      paddingVertical: Styles.Spacing.m0,
    },
    totalCaloriesLabel: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.Colors.PayNew.black01,
    },
    sectionCalStyles: {
      fontSize: Styles.Fonts.f1,
      marginRight: Styles.Spacing.m2,
      fontWeight: Styles.bold,
      color: Styles.darkColor,
    },
    productModifierContainer: {
      marginHorizontal: Styles.Spacing.m3,
    },
    checkBoxWrapper: {
      padding: Styles.Spacing.m1,
      backgroundColor: Styles.white,
      marginLeft: Styles.Spacing.m0,
      margin: null,
      justifyContent: 'center',
      minHeight: Styles.Heights.h3,
    },
    checkBoxText: {
      marginLeft: Styles.Spacing.m2,
      color: Styles.darkColor,
    },
    optionText: {
      fontSize: Styles.Fonts.f0,
      marginLeft: Styles.Spacing.m2,
      color: Styles.darkColor,
      marginTop: -Styles.Spacing.m1 / 2,
      marginBottom: 5,
    },
    helperText: {
      alignSelf: 'flex-end',
      fontSize: Styles.Fonts.f8,
      fontFamily: Styles.FontFamily.robotoRegular,
      fontWeight: '400',
      color: Styles.Colors.PayNew.darkHuesBase04,
      marginRight: Styles.Spacing.m2,
    },
    titleRow: {
      justifyContent: 'space-between',
      flexDirection: 'row',
    },
    freeTextContainer: {maxHeight: 56},
    freeTextContent: {
      paddingTop: Styles.Spacing.m2,
      paddingBottom:
        Platform.OS === 'ios' ? Styles.Spacing.m4 * 3 : Styles.Spacing.m1,
    },
  });
}
export function radioButtonProductModifier(
  buttons: ProductModifierRadioButton[],
  values: string[],
  showCalories: boolean,
  showUnitName: string,
  onPress,
): JSX.Element {
  return (
    <>
      {buttons.map((obj, i) => {
        const isSelected = values.includes(obj.value);
        return (
          <View
            accessible={true}
            accessibilityState={{
              selected: isSelected,
            }}
            key={obj.value + '-' + i}
            style={productModifierStyles().customizationDivider}
            testID="qa_ModifierContainer"
            nativeID="qa_ModifierContainer"
          >
            <View style={{marginTop: 2}}>
              <CustomToggleComponent
                accessibilityLabel={obj.label}
                selected={isSelected}
                type={CustomToggleComponentType.Radio}
                onPress={() => onPress(obj.value)}
                testID="qa_Modifier_radio"
              />
            </View>
            <View style={styles.modifierLeftView}>
              <Text
                accessibilityLabel={`${obj.label}, `}
                aria-label={`${obj.label}, `}
                style={styles.modifierText}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
                accessible
                testID="qa_ModifierName_txt"
                nativeID="qa_ModifierName_txt"
              >
                {obj.label}
              </Text>
              {showCalories && checkValue(obj.calories) && (
                <Text
                  accessibilityLabel={`${
                    obj.calories
                  } ${Localized.Labels.calories.toLowerCase()}`}
                  aria-label={`${
                    obj.calories
                  } ${Localized.Labels.calories.toLowerCase()}`}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
                  style={styles.priceText}
                  accessible
                  testID="qa_ModifierCal_txt"
                  nativeID="qa_ModifierCal_txt"
                >
                  {`(${obj.calories} ${showUnitName})`}
                </Text>
              )}
            </View>
            <View style={productModifierStyles().checkboxCalorieContainer}>
              {obj.price !== null && (
                <Text
                  accessibilityLabel={`${obj.price}, `}
                  aria-label={`${obj.price}, `}
                  style={styles.calorieText}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
                  accessible
                  testID="qa_ModifierPrice_txt"
                  nativeID="qa_ModifierPrice_txt"
                >
                  {obj.price}
                </Text>
              )}
            </View>
          </View>
        );
      })}
    </>
  );
}

export function checkboxProductModifiers(
  value: ProductModifierValue,
  price: string,
  calories: string,
  modifierValues: string[],
  showUnitName: string,
  showCalories: boolean,
  onPress,
): JSX.Element {
  return (
    <View
      accessible={true}
      key={value.id}
      style={productModifierStyles().customizationDivider}
      testID="qa_ModifierContainer"
      nativeID="qa_ModifierContainer"
    >
      <View style={{marginTop: 2}}>
        <CustomToggleComponent
          accessibilityLabel={value.name}
          selected={modifierValues.includes(value.id)}
          type={CustomToggleComponentType.Checkbox}
          onPress={() => onPress(value.id)}
          testID="qa_Modifier_checkbox"
        />
      </View>
      <View style={styles.modifierLeftView}>
        <Text
          accessibilityLabel={`${value.name}, `}
          aria-label={`${value.name}, `}
          style={styles.modifierText}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          accessible
          testID="qa_ModifierName_txt"
          nativeID="qa_ModifierName_txt"
        >
          {value.name}
        </Text>
        {showCalories && checkValue(value.calories) && (
          <Text
            style={styles.priceText}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            accessibilityLabel={`${calories}, ${showUnitName}`}
            aria-label={`${calories}, ${showUnitName}`}
            accessible
            testID="qa_ModifierCal_txt"
            nativeID="qa_ModifierCal_txt"
          >
            {`(${value?.calories} ${showUnitName})`}
          </Text>
        )}
      </View>
      <View style={productModifierStyles().checkboxCalorieContainer}>
        {price !== null && (
          <Text
            accessibilityLabel={`${price}, `}
            aria-label={`${price}, `}
            style={styles.calorieText}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            accessible
            testID="qa_ModifierPrice_txt"
            nativeID="qa_ModifierPrice_txt"
          >
            {price}
          </Text>
        )}
      </View>
    </View>
  );
}
export function getCounterText(value, FREE_TEXT_MAX_LENGTH): string {
  return `${value?.length || 0}/${FREE_TEXT_MAX_LENGTH}`;
}

export function recentOrderButtonStyle(): RecentOrdersButtonStylesDescriptor {
  return StyleSheet.create({
    marginStyle: {
      marginTop: 0,
      marginBottom: 0,
    },
    recentOrderText: {
      color: Styles.Colors.Canteen.primary,
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.robotoRegular,
      fontWeight: '400',
    },
    recentOrderIcon: {
      color: Styles.Colors.Canteen.lightGreen,
    },
    textUnderline: {
      borderBottomWidth: 1,
      borderBottomColor: Styles.Colors.Canteen.primary,
      width: '100%',
    },
  });
}

export function checkoutBarUI({
  numItems,
  onPress,
  totalAmount,
}: CheckoutBarProps) {
  return (
    <>
      {numItems > 0 && (
        <View
          style={{
            marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
            marginBottom: Styles.Spacing.m3 + Styles.Spacing.m2,
            marginTop: Styles.Spacing.m3,
            alignSelf: 'center',
          }}
        >
          <BarButton
            leftIcon={
              <View>
                <CartImage width={24} height={24} />
                <View style={styles.badge}>
                  {numItems > 0 && (
                    <Text
                      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
                      style={styles.badgeText}
                    >
                      {numItems}
                    </Text>
                  )}
                </View>
              </View>
            }
            leftText={Localized.Buttons.checkout}
            onPress={onPress}
            buttonViewStyle={{
              width: Platform.OS === 'web' ? '50%' : '100%',
              backgroundColor: Styles.Colors.Canteen.primary,
              justifyContent: 'space-between',
              height: Styles.Heights.touchTargetHeight1 + 2,
            }}
            containerStyle={{
              width: screenWidth,
              alignItems: 'center',
              justifyContent: 'center',
              paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
            }}
            rightText={totalAmount}
            textStyle={{
              fontFamily: Styles.FontFamily.robotoRegular,
              color: Styles.Colors.PayNew.white01,
              fontSize: Styles.Fonts.f1,
              fontWeight: '700',
            }}
            testID="qa_Checkout_Btn"
            leftTestID="qa_CartCount_txt"
            rightTestID="qa_CheckoutAmount_txt"
          />
        </View>
      )}
    </>
  );
}

export function requiredModifiersView(name: string): JSX.Element {
  return (
    <View style={productModifierStyles().requiredViewStyles}>
      <Text
        accessible={true}
        accessibilityLabel={`${name} section`}
        aria-label={`${name} section`}
        style={productModifierStyles().titleText}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
      >
        {`${name}*`}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Styles.darkColor,
    flexDirection: 'row',
  },
  wrapper: {
    position: 'relative',
    flex: 3,
    flexDirection: 'column',
  },
  content: {
    flexDirection: 'column',
    flex: 1,
    paddingHorizontal: Styles.Spacing.m3,
    paddingBottom: Styles.Spacing.m3,
    paddingVertical: Styles.Spacing.m2,
  },
  title: {
    color: Styles.white,
    fontSize: Styles.Fonts.f1,
    fontWeight: '600',
  },
  description: {
    color: Styles.white,
    fontSize: Styles.Fonts.f0,
  },
  row: {
    flexDirection: 'row',
  },
  itemAddedFeedbackView: {
    position: 'absolute',
    top: Styles.Spacing.m0,
    left: Styles.Spacing.m0,
    right: Styles.Spacing.m0,
    bottom: Styles.Spacing.m0,
    flexDirection: 'row',
  },
  cart: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    alignSelf: 'stretch',
    flex: 1,
    backgroundColor: Styles.positiveColor,
    paddingHorizontal: Styles.Spacing.m3,
    paddingVertical: Styles.Spacing.m2 + PixelRatio.getFontScale() * 1.3,
    color: Styles.positiveColor,
  },
  cartText: {
    fontSize: Styles.Fonts.f1 * 1.1,
    fontWeight: '600',
    paddingRight: Styles.Spacing.m2,
    color: Styles.white,
  },
  badge: {
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    right: Styles.Spacing.m0,
    top: Styles.Spacing.m0,
    bottom: Styles.Spacing.m1 + 2,
    left: Platform.OS === 'ios' ? Styles.Spacing.m1 - 2 : 1,
    zIndex: 1,
  },
  badgeText: {
    fontSize: Styles.Fonts.f0,
    fontWeight: 'bold',
    fontFamily: Styles.FontFamily.robotoRegular,
    color: Styles.Colors.Canteen.primary,
  },
  dummy: {
    backgroundColor: Styles.darkColor,
    paddingTop: Styles.Spacing.m1,
    paddingBottom: Styles.Spacing.m3,
    paddingLeft: Styles.Spacing.m1,
    position: 'absolute',
    right: Styles.Spacing.m0,
    top: Styles.Spacing.m0,
    bottom: Styles.Spacing.m0,
    left: Styles.Spacing.m0,
    zIndex: 1,
  },
  requiredText: {
    fontSize: Styles.Fonts.f1,
    fontStyle: 'italic',
    color: Styles.dangerColor,
  },
  calorieSectionView: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flex: 1,
  },
  modifierLeftView: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginLeft: Styles.Spacing.m2 + 2,
  },
  calorieText: {
    fontFamily: Styles.FontFamily.robotoRegular,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    color: Styles.Colors.PayNew.black01,
    textAlign: 'right',
  },
  modifierText: {
    fontSize: Styles.Fonts.f1,
    fontFamily: Styles.FontFamily.robotoRegular,
    fontWeight: '400',
    color: Styles.Colors.PayNew.black01,
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    maxWidth: '65%',
  },
  priceText: {
    fontFamily: Styles.FontFamily.robotoRegular,
    fontSize: Styles.Fonts.f1,
    color: Styles.Colors.PayNew.black01,
    fontWeight: '400',
    marginLeft: Styles.Spacing.m1,
  },
});

export function getActiveIconColor() {
  return Styles.primaryColor;
}
export function getInActiveIconColor() {
  return Styles.darkColor;
}

export function getMenuListCompnentsFontFamily() {
  return Styles.FontFamily.robotoRegular;
}

export function recentOrdersHideDetailsColors() {
  return Styles.Colors.Canteen.green;
}
export function numberOfColumnsFlatlist() {
  return 1;
}

export function subMenuStyles() {
  return StyleSheet.create({
    container: {
      flex: 1,
      marginBottom: Styles.Spacing.m3 + Styles.Spacing.m2,
    },
  });
}

export function getModifierPrice(price, props) {
  if (price !== null && price > 0) {
    return `${formatCurrency(props, price, AccountStore.getCurrency())}`;
  }
}

export function customisedCalorieSection() {
  return null;
}

export function calorieColor() {
  return Styles.Colors.PayNew.darkHuesBase03;
}
export function pointsFontSize() {
  return Styles.Fonts.f0;
}
export function rewardsLabelSize(): number {
  return Styles.Fonts.f0;
}
export function rewardsLabelColor(): string {
  return Styles.Colors.Canteen.green;
}

export default {
  customTilesButtonStyles,
  pickupLocationListStyles,
  recentOrderButtonStyle,
  productModifierStyles,
  radioButtonProductModifier,
  checkboxProductModifiers,
  getCounterText,
  checkoutBarUI,
  requiredModifiersView,
  pickupLocationInnerCircleBackgroundColor,
  pickupLocationOuterCircleBorderColor,
  getActiveIconColor,
  getInActiveIconColor,
  getMenuListCompnentsFontFamily,
  recentOrdersHideDetailsColors,
  numberOfColumnsFlatlist,
  subMenuStyles,
  getModifierPrice,
  customisedCalorieSection,
  calorieColor,
  pointsFontSize,
  rewardsLabelSize,
  rewardsLabelColor,
};
